(function ($, Drupal) {
  Drupal.behaviors.lazyLoadForAjax = {
    attach: function (context, settings) {
      $(document).ready(function () {
        $('.ecommerce__picture img, div[class^="product-variation-"] img, img.modal-ecommerce-title-logo', context).once('lazyLoadForAjax').each(function () {
          var item = $(this);
          item.attr({
            src: item.attr('data-src')
          }).removeClass('lazy').addClass('animate');
        });
      });
    }
  };
})(jQuery, Drupal);
